import ShowToast from "../../../../widget/common/ui/Toast";
import ApiService from "../../../../service/api/ApiService";
import ApiUrls from "../../../../service/api/ApiUrls";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";

const ARFProvider = new (class ARFProvider {
  submitARFAPI = async ({
    formStatus = "1",
    conversationId = "",
    departmentId = "",
    name = "",
    date = "",
    time = "",
    noPeople = "",
    subject = "",
    message = "",
  }: {
    formStatus: "1" | "2" | "3";
    conversationId: string;
    departmentId: string;
    name?: string;
    date: string;
    time: string;
    noPeople?: string;
    subject?: string;
    message: string;
  }): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const branchId: string = CacheStorage.getValue(StorageKeys.branch_id);

    const url: string = `${ApiUrls.baseUrl}arf/create_appointment_reservation_feedback_request`;
    const body: any = {
      account_id: accountId,
      branch_id: branchId,
      conv_id: conversationId,
      department_id: departmentId,
      form_type: formStatus,
      name: name.trim(),
      date: date,
      time: time,
      description: message.trim(),
      subject: formStatus === "1" ? subject.trim() : "",
      no_people: formStatus === "3" ? noPeople.trim() : "",
    };

    console.log(body);
    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default ARFProvider;
